// src/main.js
import './app.css';
// import './fonts/font-awesome.css'
import App from './App.svelte';




const app = new App({
  target: document.body,
});

export default app;
